import * as C from '../../constants';
import defaultState from './defaultState';

export default {

  [C.SKI_SCHOOL_RESET_STATE](state) {
    Object.assign(state, defaultState());
  },

  // region Available ski school products
  [C.SKI_SCHOOL_AVAILABLE_PRODUCTS_LOAD_PENDING](state) {
    state.availableSchoolProducts = {
      ...state.availableSchoolProducts,
      itemsLoading: true,
      itemsError: undefined,
    };
    state.schools = {
      ...state.schools,
      saveLoading: false,
      saveError: undefined,
    };
  },

  [C.SKI_SCHOOL_AVAILABLE_PRODUCTS_LOAD_FAILURE](state, payload) {
    state.availableSchoolProducts = {
      ...state.availableSchoolProducts,
      items: [],
      itemsLoading: false,
      itemsError: payload,
    };
  },

  [C.SKI_SCHOOL_AVAILABLE_PRODUCTS_LOAD_SUCCESS](state, payload) {
    state.availableSchoolProducts = {
      ...state.availableSchoolProducts,
      items: payload,
      itemsLoading: false,
      itemsError: undefined,
    };
  },
  // endregion

  // region Ski school meeting points
  [C.SKI_SCHOOL_MEETING_POINTS_LOAD_PENDING](state) {
    state.meetingPoints = {
      ...state.meetingPoints,
      itemsLoading: true,
      itemsError: undefined,
    };
  },

  [C.SKI_SCHOOL_MEETING_POINTS_LOAD_FAILURE](state, payload) {
    state.meetingPoints = {
      ...state.meetingPoints,
      items: [],
      itemsLoading: false,
      itemsError: payload,
    };
  },

  [C.SKI_SCHOOL_MEETING_POINTS_LOAD_SUCCESS](state, payload) {
    const items = [
      ...state.meetingPoints.items,
      ...payload.items,
    ];
    state.meetingPoints = {
      ...state.meetingPoints,
      items,
      itemsLoading: false,
      itemsError: undefined,
    };
  },
  // endregion

  // region Ski school
  [C.SKI_SCHOOL_PRODUCTS_LOAD_PENDING](state) {
    state.schools = {
      ...state.schools,
      itemsLoading: true,
      itemsError: undefined,
      saveLoading: false,
      saveError: undefined,
    };
  },

  [C.SKI_SCHOOL_PRODUCTS_LOAD_FAILURE](state, payload) {
    state.schools = {
      ...state.schools,
      items: [],
      itemsLoading: false,
      itemsError: payload,
    };
  },

  [C.SKI_SCHOOL_PRODUCTS_LOAD_SUCCESS](state, payload) {
    state.schools = {
      ...state.schools,
      items: payload,
      itemsLoading: false,
      itemsError: undefined,
    };
  },

  [C.SKI_SCHOOL_CREATE_PENDING](state) {
    state.availableSchoolProducts = {
      ...state.availableSchoolProducts,
      saveLoading: true,
      saveError: undefined,
    };
  },

  [C.SKI_SCHOOL_CREATE_SUCCESS](state) {
    state.availableSchoolProducts = {
      ...state.availableSchoolProducts,
      saveLoading: false,
      saveError: undefined,
    };
  },

  [C.SKI_SCHOOL_CREATE_FAILURE](state, payload) {
    state.availableSchoolProducts = {
      ...state.availableSchoolProducts,
      saveLoading: false,
      saveError: payload,
    };
  },

  [C.SKI_SCHOOL_UPDATE_PENDING](state) {
    state.schools = {
      ...state.schools,
      saveLoading: true,
      saveError: undefined,
    };
  },

  [C.SKI_SCHOOL_UPDATE_SUCCESS](state) {
    state.schools = {
      ...state.schools,
      saveLoading: false,
      saveError: undefined,
    };
  },

  [C.SKI_SCHOOL_UPDATE_FAILURE](state, payload) {
    state.schools = {
      ...state.schools,
      saveLoading: false,
      saveError: payload,
    };
  },

  [C.SKI_SCHOOL_PRICE_UPDATE_PENDING](state) {
    state.schools = {
      ...state.schools,
      saveLoading: true,
      saveError: undefined,
    };
  },

  [C.SKI_SCHOOL_PRICE_UPDATE_SUCCESS](state) {
    state.schools = {
      ...state.schools,
      saveLoading: false,
      saveError: undefined,
    };
  },

  [C.SKI_SCHOOL_PRICE_UPDATE_FAILURE](state, payload) {
    state.schools = {
      ...state.schools,
      saveLoading: false,
      saveError: payload,
    };
  },

  [C.SKI_SCHOOL_CANCELLATION_FEE_NET_UPDATE_PENDING](state) {
    state.schools = {
      ...state.schools,
      saveLoading: true,
      saveError: undefined,
    };
  },

  [C.SKI_SCHOOL_CANCELLATION_FEE_NET_UPDATE_SUCCESS](state) {
    state.schools = {
      ...state.schools,
      saveLoading: false,
      saveError: undefined,
    };
  },

  [C.SKI_SCHOOL_CANCELLATION_FEE_NET_UPDATE_FAILURE](state, payload) {
    state.schools = {
      ...state.schools,
      saveLoading: false,
      saveError: payload,
    };
  },

  [C.SKI_SCHOOL_DELETE_PENDING](state) {
    state.schools = {
      ...state.schools,
      saveLoading: true,
      saveError: undefined,
    };
    state.availableSchoolProducts = {
      ...state.availableSchoolProducts,
      saveLoading: true,
      saveError: undefined,
    };
  },

  [C.SKI_SCHOOL_DELETE_SUCCESS](state, items) {
    state.schools = {
      ...state.schools,
      items,
      saveLoading: false,
      saveError: undefined,
    };
    state.availableSchoolProducts = {
      ...state.availableSchoolProducts,
      saveLoading: false,
      saveError: undefined,
    };
  },

  [C.SKI_SCHOOL_DELETE_FAILURE](state, payload) {
    state.schools = {
      ...state.schools,
      saveLoading: false,
      saveError: payload,
    };
    state.availableSchoolProducts = {
      ...state.availableSchoolProducts,
      saveLoading: false,
      saveError: payload,
    };
  },

  [C.SKI_SCHOOL_MEETING_POINT_UPDATE_PENDING](state) {
    state.meetingPoints = {
      ...state.meetingPoints,
      itemsLoading: true,
      itemsError: undefined,
    };
  },

  [C.SKI_SCHOOL_MEETING_POINT_UPDATE_SUCCESS](state) {
    state.meetingPoints = {
      ...state.meetingPoints,
      itemsLoading: false,
      itemsError: undefined,
    };
  },

  [C.SKI_SCHOOL_MEETING_POINT_UPDATE_FAILURE](state, payload) {
    state.meetingPoints = {
      ...state.meetingPoints,
      itemsLoading: false,
      itemsError: payload,
    };
  },

  [C.SKI_SCHOOL_STOP_PENDING](state) {
    state.schools = {
      ...state.schools,
      saveLoading: true,
      saveError: undefined,
    };
  },

  [C.SKI_SCHOOL_STOP_SUCCESS](state) {
    state.schools = {
      ...state.schools,
      saveLoading: false,
      saveError: undefined,
    };
  },

  [C.SKI_SCHOOL_STOP_FAILURE](state, payload) {
    state.schools = {
      ...state.schools,
      saveLoading: false,
      saveError: payload,
    };
  },

  [C.SKI_SCHOOL_CANCEL_PENDING](state) {
    state.schools = {
      ...state.schools,
      saveLoading: true,
      saveError: undefined,
    };
  },

  [C.SKI_SCHOOL_CANCEL_SUCCESS](state) {
    state.schools = {
      ...state.schools,
      saveLoading: false,
      saveError: undefined,
    };
  },

  [C.SKI_SCHOOL_CANCEL_FAILURE](state, payload) {
    state.schools = {
      ...state.schools,
      saveLoading: false,
      saveError: payload,
    };
  },

  [C.SKI_SCHOOL_STATUS_UPDATE_PENDING](state) {
    state.schools = {
      ...state.schools,
      saveLoading: true,
      saveError: undefined,
    };
  },

  [C.SKI_SCHOOL_STATUS_UPDATE_SUCCESS](state) {
    state.schools = {
      ...state.schools,
      saveLoading: false,
      saveError: undefined,
    };
  },

  [C.SKI_SCHOOL_STATUS_UPDATE_FAILURE](state, payload) {
    state.schools = {
      ...state.schools,
      saveLoading: false,
      saveError: payload,
    };
  },

  [C.SKI_SCHOOL_START_DATE_TIME_UPDATE_PENDING](state) {
    state.schools = {
      ...state.schools,
      saveLoading: true,
      saveError: undefined,
    };
  },

  [C.SKI_SCHOOL_START_DATE_TIME_UPDATE_SUCCESS](state) {
    state.schools = {
      ...state.schools,
      saveLoading: false,
      saveError: undefined,
    };
  },

  [C.SKI_SCHOOL_START_DATE_TIME_UPDATE_FAILURE](state, payload) {
    state.schools = {
      ...state.schools,
      saveLoading: false,
      saveError: payload,
    };
  },

  [C.SKI_SCHOOL_SUPPLIER_COMMENT_UPDATE_PENDING](state) {
    state.schools = {
      ...state.schools,
      saveLoading: true,
      saveError: undefined,
    };
  },

  [C.SKI_SCHOOL_SUPPLIER_COMMENT_UPDATE_SUCCESS](state) {
    state.schools = {
      ...state.schools,
      saveLoading: false,
      saveError: undefined,
    };
  },

  [C.SKI_SCHOOL_SUPPLIER_COMMENT_UPDATE_FAILURE](state, payload) {
    state.schools = {
      ...state.schools,
      saveLoading: false,
      saveError: payload,
    };
  },

  [C.SKI_SCHOOL_CUSTOMER_COMMENT_UPDATE_PENDING](state) {
    state.schools = {
      ...state.schools,
      saveLoading: true,
      saveError: undefined,
    };
  },

  [C.SKI_SCHOOL_CUSTOMER_COMMENT_UPDATE_SUCCESS](state) {
    state.schools = {
      ...state.schools,
      saveLoading: false,
      saveError: undefined,
    };
  },

  [C.SKI_SCHOOL_CUSTOMER_COMMENT_UPDATE_FAILURE](state, payload) {
    state.schools = {
      ...state.schools,
      saveLoading: false,
      saveError: payload,
    };
  },

  [C.SKI_SCHOOL_CHANGE_STATUS_PENDING](state) {
    state.schools = {
      ...state.schools,
      saveLoading: true,
      saveError: undefined,
    };
  },

  [C.SKI_SCHOOL_CHANGE_STATUS_SUCCESS](state) {
    state.schools = {
      ...state.schools,
      saveLoading: false,
      saveError: undefined,
    };
  },

  [C.SKI_SCHOOL_CHANGE_STATUS_FAILURE](state, payload) {
    state.schools = {
      ...state.schools,
      saveLoading: false,
      saveError: payload,
    };
  },

  [C.SKI_SCHOOL_SUPPLIER_REF_UPDATE_PENDING](state) {
    state.schools = {
      ...state.schools,
      saveLoading: true,
      saveError: undefined,
    };
  },

  [C.SKI_SCHOOL_SUPPLIER_REF_UPDATE_SUCCESS](state, items) {
    state.schools = {
      ...state.schools,
      items,
      saveLoading: false,
      saveError: undefined,
    };
  },

  [C.SKI_SCHOOL_SUPPLIER_REF_UPDATE_FAILURE](state, payload) {
    state.schools = {
      ...state.schools,
      saveLoading: false,
      saveError: payload,
    };
  },

  [C.SKI_SCHOOL_PARTICIPANT_CREATE_PENDING](state) {
    state.schools = {
      ...state.schools,
      saveLoading: true,
      saveError: undefined,
    };
  },

  [C.SKI_SCHOOL_PARTICIPANT_CREATE_SUCCESS](state) {
    state.schools = {
      ...state.schools,
      saveLoading: false,
      saveError: undefined,
    };
  },

  [C.SKI_SCHOOL_PARTICIPANT_CREATE_FAILURE](state, payload) {
    state.schools = {
      ...state.schools,
      saveLoading: false,
      saveError: payload,
    };
  },

  [C.SKI_SCHOOL_PARTICIPANT_DELETE_PENDING](state) {
    state.schools = {
      ...state.schools,
      saveLoading: true,
      saveError: undefined,
    };
  },

  [C.SKI_SCHOOL_PARTICIPANT_DELETE_SUCCESS](state) {
    state.schools = {
      ...state.schools,
      saveLoading: false,
      saveError: undefined,
    };
  },

  [C.SKI_SCHOOL_PARTICIPANT_DELETE_FAILURE](state, payload) {
    state.schools = {
      ...state.schools,
      saveLoading: false,
      saveError: payload,
    };
  },

  [C.SKI_SCHOOL_SEND_REQUEST_EMAIL_PENDING](state) {
    state.schools = {
      ...state.schools,
      itemsLoading: true,
      itemsError: undefined,
    };
  },

  [C.SKI_SCHOOL_SEND_REQUEST_EMAIL_SUCCESS](state) {
    state.schools = {
      ...state.schools,
      itemsLoading: false,
      itemsError: undefined,
    };
  },

  [C.SKI_SCHOOL_SEND_REQUEST_EMAIL_FAILURE](state, payload) {
    state.schools = {
      ...state.schools,
      itemsLoading: false,
      itemsError: payload,
    };
  },
  // endregion

  // region Ski school search available products
  [C.SKI_SCHOOL_SEARCH_BOOKING_PARTICIPANT_SET](state, selectedBookingParticipantId) {
    state.search.selectedBookingParticipantId = selectedBookingParticipantId;
  },

  [C.SKI_SCHOOL_SEARCH_NUMBER_OF_DAYS_SET](state, selectedNumberOfDays) {
    state.search.selectedNumberOfDays = selectedNumberOfDays;
  },

  [C.SKI_SCHOOL_SEARCH_CLEAR_FILTERS_SET](state) {
    state.search.selectedNumberOfDays = undefined;
    state.search.selectedLessonTypeId = undefined;
    state.search.selectedWeekDayNumber = undefined;
    state.search.selectedLessonDuration = undefined;
    state.search.selectedNumberOfPersons = undefined;
    state.search.selectedSkiTypes = [];
  },

  [C.SKI_SCHOOL_SEARCH_AREA_SET](state, selectedAreaId) {
    state.search.selectedAreaId = selectedAreaId;
  },

  [C.SKI_SCHOOL_SEARCH_LESSON_TYPE_SET](state, selectedLessonTypeId) {
    state.search.selectedLessonTypeId = selectedLessonTypeId;
  },

  [C.SKI_SCHOOL_SEARCH_WEEK_DAY_NUMBER_SET](state, selectedWeekDayNumber) {
    state.search.selectedWeekDayNumber = selectedWeekDayNumber;
  },

  [C.SKI_SCHOOL_SEARCH_LESSON_DURATION_SET](state, selectedLessonDuration) {
    state.search.selectedLessonDuration = selectedLessonDuration;
  },

  [C.SKI_SCHOOL_SEARCH_NUMBER_OF_PERSONS_SET](state, selectedNumberOfPersons) {
    state.search.selectedNumberOfPersons = selectedNumberOfPersons;
  },

  [C.SKI_SCHOOL_SEARCH_SKI_TYPES_SET](state, selectedSkiTypes) {
    state.search.selectedSkiTypes = selectedSkiTypes;
  },
  // endregion

  // region Ski school change product
  [C.SKI_SCHOOL_CHANGE_PRODUCT_BOOKING_PARTICIPANT_SET](state, selectedBookingParticipantId) {
    state.changeProduct.selectedBookingParticipantId = selectedBookingParticipantId;
  },

  [C.SKI_SCHOOL_CHANGE_PRODUCT_NUMBER_OF_DAYS_SET](state, selectedNumberOfDays) {
    state.changeProduct.selectedNumberOfDays = selectedNumberOfDays;
  },

  [C.SKI_SCHOOL_CHANGE_PRODUCT_PERSON_CATEGORY_SET](state, personCategoryId) {
    state.changeProduct.selectedPersonCategoryId = personCategoryId;
  },

  [C.SKI_SCHOOL_CHANGE_PRODUCT_AREA_SET](state, selectedAreaId) {
    state.changeProduct.selectedAreaId = selectedAreaId;
  },

  [C.SKI_SCHOOL_CHANGE_PRODUCT_LESSON_TYPE_SET](state, selectedLessonTypeId) {
    state.changeProduct.selectedLessonTypeId = selectedLessonTypeId;
  },

  [C.SKI_SCHOOL_CHANGE_PRODUCT_WEEK_DAY_NUMBER_SET](state, selectedWeekDayNumber) {
    state.changeProduct.selectedWeekDayNumber = selectedWeekDayNumber;
  },

  [C.SKI_SCHOOL_CHANGE_PRODUCT_LESSON_DURATION_SET](state, selectedLessonDuration) {
    state.changeProduct.selectedLessonDuration = selectedLessonDuration;
  },

  [C.SKI_SCHOOL_CHANGE_PRODUCT_LEVEL_SET](state, selectedLevelId) {
    state.changeProduct.selectedLevelId = selectedLevelId;
  },

  [C.SKI_SCHOOL_CHANGE_PRODUCT_NUMBER_OF_PERSONS_SET](state, selectedNumberOfPersons) {
    state.changeProduct.selectedNumberOfPersons = selectedNumberOfPersons;
  },

  [C.SKI_SCHOOL_CHANGE_PRODUCT_SKI_TYPE_SET](state, selectedSkiTypeId) {
    state.changeProduct.selectedSkiTypeId = selectedSkiTypeId;
  },
  // endregion
};



// WEBPACK FOOTER //
// ./src/store/modules/ski/school/mutations.js